﻿import DomElementsBase from "@grindex-common/abstracts/DomElementsBase.class";
import { elements } from "@grindex-common/helpers/cssGlobals";

const CLASS_MOBILE_HEADER = "mobile-tab-header";
const ID_TABS_CONTENT = "#tabsContent";
const SELECTOR_TAB = "[data-tab]";
const SELECTOR_TITLE = ".tab-content-title";

export default class TabListDom extends DomElementsBase {
	constructor($module) {
		const selectors = [elements.TAB_HEADERS, ID_TABS_CONTENT, SELECTOR_TITLE];

		super($module, selectors);
	}

	getHeaderContainer() {
		return this.getElement(elements.TAB_HEADERS);
	}

	getContentContainer() {
		return this.getElement(ID_TABS_CONTENT);
	}

	getExistingHeaders() {
		return this.getHeaderContainer().querySelectorAll("span");
	}

	getTabName(dom) {
		const headers = dom.querySelectorAll(SELECTOR_TITLE);

		return headers.length > 0 ? headers[headers.length - 1].innerText : "unknown";
	}

	appendTabHeading($header) {
		this.getHeaderContainer().appendChild($header);
	}

	prependTabHeading($header, $beforeElement) {
		$beforeElement.before($header);
	}

	createHeader(tabName, $dom) {
		const $header = document.createElement("span");

		$header.className = CLASS_MOBILE_HEADER;
		$header.dataset.tab = $dom.querySelector(SELECTOR_TAB).dataset.tab;
		$header.innerText = tabName.trim();

		return $header;
	}

	getNextLargerHeader(header) {
		return Array.prototype.find.call(this.getExistingHeaders(), (existing) => existing.dataset.tab * 1 > header.dataset.tab * 1);
	}
}
